var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconPotentielleMandate = function SvgIconPotentielleMandate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 160
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "788-a",
    x1: 0.495,
    y1: 0.004,
    x2: 0.506,
    y2: 0.999,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d9d9c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "788-c",
    x1: 0.499,
    y1: -0.008,
    x2: 0.502,
    y2: 1.523,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59529e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4b4382"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "788-d",
    x1: 0.5,
    y1: 0.029,
    x2: 0.5,
    y2: 1.738,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6c52cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0a1343"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "788-e",
    x1: 0.483,
    y1: 0.004,
    x2: 0.511,
    y2: 0.992,
    xlinkHref: "#788-a"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "788-b",
    x: 40,
    y: 33,
    width: 120.779,
    height: 100.254,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h200v160H0z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#788-b)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.78 23.091a9.243 9.243 0 0 0-9.206-9.206H73.425V12.3A12.383 12.383 0 0 0 62.181 0H41.655a12.3 12.3 0 0 0-12.3 12.3v1.585H9.206A9.243 9.243 0 0 0 0 23.091V48.3c.377.226.83.377 1.207.6v24.148a9.243 9.243 0 0 0 9.206 9.206H92.29a9.243 9.243 0 0 0 9.206-9.206V48.9c.377-.226.83-.377 1.207-.6V23.1ZM35.467 12.3a6.216 6.216 0 0 1 6.188-6.188h19.469a6.216 6.216 0 0 1 6.188 6.188v1.585H35.467Z",
    transform: "translate(49 39)",
    style: {
      fill: "url(#788-a)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.012 13.885V12.3A6.216 6.216 0 0 1 51.2 6.112h19.47a6.216 6.216 0 0 1 6.188 6.188v1.585h6.188V12.3A12.383 12.383 0 0 0 71.8 0H51.2a12.3 12.3 0 0 0-12.3 12.3v1.585Z",
    transform: "translate(39.455 39)",
    style: {
      fill: "#0a1343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.6 55.6v31.09a9.243 9.243 0 0 0 9.206 9.21h81.877a9.243 9.243 0 0 0 9.206-9.206V55.6c-12.9 6.565-30.562 10.716-50.711 10.716S14.58 62.165 1.6 55.6Z",
    transform: "translate(48.607 25.357)",
    style: {
      fill: "#0a1343"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5 18.4H9.206A9.243 9.243 0 0 0 0 27.606v25.2c12.98 6.565 31.241 10.716 51.39 10.716s38.41-4.075 51.39-10.716v-25.2A9.308 9.308 0 0 0 93.5 18.4Z",
    transform: "translate(49 34.485)",
    style: {
      fill: "url(#788-c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5 18.4H9.206A9.243 9.243 0 0 0 0 27.606v25.2c12.98 6.565 31.241 10.716 51.39 10.716s38.41-4.075 51.39-10.716v-25.2A9.308 9.308 0 0 0 93.5 18.4Z",
    transform: "translate(49 34.485)",
    style: {
      fill: "url(#788-d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.665 82.005h-4.452a2.109 2.109 0 0 1-2.113-2.113V66.913a2.109 2.109 0 0 1 2.113-2.113h4.452a2.109 2.109 0 0 1 2.113 2.113v12.9a2.175 2.175 0 0 1-2.113 2.192Z",
    transform: "translate(34.007 23.1)",
    style: {
      fill: "url(#788-e)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(140.062 11.599)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(-5.062 -5.062)",
    style: {
      fill: "#f7f7f9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.6 30.635 9.987 9.987L45.21 20l-5.271 5.271",
    transform: "translate(-2.486 -2.892)",
    style: {
      stroke: "#19aa2c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.465,
    cy: 27.465,
    r: 27.465,
    style: {
      stroke: "#19aa2c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: 3,
      fill: "none"
    }
  })));
};
export default SvgIconPotentielleMandate;